import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { Container } from 'react-bootstrap'

import queryGraphql from '@shared/components/queryGraphql'
import { GET_AUTHOR_BY_ID, GET_AUTHOR_ARTICLES } from '@graphql/author/author.query'
import Error from '@shared/components/error'
import Layout from '@shared/components/layout'
import { GET_SEO_DATA } from '@graphql/article/article.query'
import { checkRedirectionStatus, handleApiError } from '@shared-submodule/utils'

const BreadcrumbNav = dynamic(() => import('@shared/components/breadcrumbNav'))
const AuthorDetailCard = dynamic(() => import('@shared/components/author/authorDetailCard'))
const AuthorArticles = dynamic(() => import('@shared/components/author/authorArticles'))
const ATSAds = dynamic(() => import('@shared/components/atsAds'), { ssr: false })

function AuthorDetails({ authorData, authorID, articles, fantasyArticles, seoData }) {
  return (
    <Layout
      data={{
        oSeo: {
          ...seoData?.getSeoData,
          sTitle: authorData?.sFName,
          sDescription: 'Catch the latest Sports News Headlines of the day, Sports Breaking News Today, Latest Indian Cricket News, Cricket News Headlines, Live Cricket Match Today, Trending News, Cricket Events and Cricket Matches'
        }
      }}
    >
      <Container className="pt-3">
        <ATSAds />
        <BreadcrumbNav />
        <AuthorDetailCard data={authorData} />
        <AuthorArticles articles={articles} fantasyArticles={fantasyArticles} authorID={authorID} />
      </Container>
    </Layout>
  )
}

export async function getServerSideProps({ res, query, resolvedUrl }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=3600')
    const { data: seoData } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: query.slug || '' } })
    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seoData?.getSeoData)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj

    const authorID = seoData.getSeoData.iId
    const {
      data: { getAuthor: authorData }
    } = await queryGraphql(GET_AUTHOR_BY_ID, { input: { _id: authorID } })
    const {
      data: { getAuthorArticles: articles }
    } = await queryGraphql(GET_AUTHOR_ARTICLES, {
      input: {
        nSkip: 1,
        nLimit: 10,
        iAuthorDId: authorID
      }
    })
    return {
      props: {
        authorData,
        authorID,
        articles,
        seoData
      }
    }
  } catch (e) {
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}

AuthorDetails.propTypes = {
  authorData: PropTypes.object,
  authorID: PropTypes.string,
  articles: PropTypes.object,
  fantasyArticles: PropTypes.object,
  seoData: PropTypes.object
}

export default Error(AuthorDetails)
